<div class="large-banner-container" [class]="{
  'banner-info': config().style === BannerStyle.Info,
  'banner-error': config().style === BannerStyle.Error,
  'banner-warning': config().style === BannerStyle.Warning,
  'banner-success': config().style === BannerStyle.Success,
  }">
  <div class="large-banner-upper">
    <div class="large-banner-title">
      <mat-icon class="large-banner-title-icon" [hidden]="!config().icon" [svgIcon]="config().icon ?? ''"></mat-icon>
      <div [hidden]="!config().title" class="large-banner-title-text">
        {{ config().title }}
      </div>
    </div>
    @let closeButtonClicked = config().closeButtonClicked;
    @if (closeButtonClicked) {
      <mat-icon class="large-banner-cross-icon" (click)="closeButtonClicked()" svgIcon="close"></mat-icon>
    }
  </div>
  <div class="large-banner-lower">
    <div [hidden]="!config().description" class="large-banner-description-text">
      {{ config().description }}
    </div>
    <div class="large-banner-buttons">
      @for (button of config().buttons; track $index) {
        <lib-button [leadingIconName]="button.leadingIconName" [trailingIconName]="button.trailingIconName"
                    [type]="button.style" (buttonClick)="button.onClick()" [size]="InputSize.small"> {{ button.title }}
        </lib-button>
      }
    </div>
  </div>
</div>
